import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { showErrorMessage, showSuccessMessage } from "helpers/toastMessage";
import { verifyEmailTokenAPI } from "services/api/userSetting";

const TOKEN_PARAM = "verified_email_token";

export default function useVerifyEmailFromURL() {
  const navigate = useNavigate();
  const [token] = useState(() => new URLSearchParams(window.location.search).get(TOKEN_PARAM));
  const handled = useRef(false);

  useEffect(() => {
    if (!token || handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.search);
    if (params.has(TOKEN_PARAM)) {
      params.delete(TOKEN_PARAM);
      navigate(
        {
          pathname: window.location.pathname,
          search: params.toString(),
          hash: window.location.hash
        },
        { replace: true }
      );
    }

    const verifyEmail = async () => {
      try {
        await verifyEmailTokenAPI(token);
        showSuccessMessage("Thank you for confirming your email address.");
      } catch (error: any) {
        if (error?.response?.status === 400) {
          showErrorMessage(
            "This verification link is invalid or has expired. Request a new one from Settings → Notifications."
          );
        } else {
          showErrorMessage("We couldn't verify your email address. Please try again later.");
        }
      }
    };

    verifyEmail();
  }, [token, navigate]);
}
